import { observer } from 'mobx-react-lite'
import { useId } from 'react'

import { useAppStore } from '@src/app/context'
import { Link } from '@src/component/link'
import Button from '@ui/Button/Button'
import { Command, CommandFooter, CommandHeader } from '@ui/Command'
import Modal from '@ui/Modal'
import { theme } from '@ui/theme'

import * as styles from './UniversalLoginReauthenticateInfoModal.css'

const updateTimeSettingsMacLink =
  'https://support.apple.com/en-ca/guide/mac-help/mchlp2996/mac'
const updateTimeSettingsWindowsLink =
  'https://support.microsoft.com/en-us/windows/set-time-date-and-time-zone-settings-in-windows-dfaa7122-479f-5b98-2a7b-fa0b6e01b261'

const UniversalLoginReauthenticateInfoModal = () => {
  const { service } = useAppStore()
  const titleId = useId()

  const reason = service.authV2.logoutReason

  if (!reason) {
    return null
  }

  const handleClose = () => {
    service.authV2.hideLogoutReason()
  }

  return (
    <Modal
      underlayColor={`rgba(${theme.palette.overlay.fullscreen})`}
      underlayClassName={styles.modal}
      className={styles.dialog}
      onClose={handleClose}
      isDismissable={true}
    >
      <Command width={464} aria-labelledby={titleId}>
        <CommandHeader
          title="You've been logged out"
          titleId={titleId}
          subtitle="It looks like your system time has not been properly synced with the world clock. To fix this, please go to your operating system settings and update your location timezone settings."
        />
        <div className={styles.content}>
          <Button asChild variant="ghost">
            <Link target="_blank" href={updateTimeSettingsWindowsLink}>
              Instructions for Windows
            </Link>
          </Button>
          <Button asChild variant="ghost">
            <Link target="_blank" href={updateTimeSettingsMacLink}>
              Instructions for Mac
            </Link>
          </Button>
        </div>
        <CommandFooter
          hideDivider={true}
          rightContent={
            <div className={styles.actionButtonsContainer}>
              <Button onClick={handleClose}>Got it</Button>
            </div>
          }
        />
      </Command>
    </Modal>
  )
}

export default observer(UniversalLoginReauthenticateInfoModal)
